import { gql } from '@/__generated__';

export const GET_ACTIVITY_LOGS = gql(`#graphql
  query GetActivityLogs($filter: ActivityLogsFilter) {
    activityLogs(filter: $filter) {
      id
      activityName
      createdAt
    }
  }
`);
